export default __webpack_public_path__ + "static/media/proposal_button_icon.f662898f.svg";